import React from 'react'
import heroImg from "../images/hero-bg.jpeg";
import styled, { keyframes } from 'styled-components';

const fadeInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const HeaderContainerSection = styled.header`
  position: relative;
  background-color: #333;
  background-image: url(${heroImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media screen and (max-width: 780px) {
    margin-top: 8.5rem;
    height: calc(100vh - 135px);
  }
  @media screen and (min-width: 820px) {
    margin-top: 7.5rem;
    height: calc(100vh - 120px);
  }
`;

const OverlayLayer = styled.div`
  position: absolute;
  background-color: #00000069;
  inset: 0;
`;

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  /* max-width: 1100px; */
  margin: 0 auto;
  padding: 1.2rem 4rem;

  @media screen and (min-width: 1180px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 3rem;
  }
  @media (min-width: 768px) and (max-width: 819px) {
    padding: 0rem 3rem;
  }
  @media screen and (max-width: 767px) {
    padding: 0rem 1rem;
  }
  @media screen and (max-width: 780px) {
    height: calc(100vh - 135px);
  }
  @media screen and (min-width: 820px) {
    height: calc(100vh - 120px);
  }
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  animation: ${fadeInLeft} 2s ease-out forwards;

  @media screen and (min-width: 1180px) {
    text-align: left;
    min-width: 730px;
  }
  @media screen and (max-width: 780px) {
    height: calc(100vh - 135px);
  }
  @media screen and (min-width: 820px) {
    height: calc(100vh - 120px);
  }
`;

const CompanyName = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #ffffff;
  white-space: nowrap;

  @media screen and (max-width: 780px) {
    font-size: 28px;
    white-space: normal;
  }
`;

const CompanyContent = styled.p`
  width: auto;
  font-size: 18px;
  color: #fff;
  text-align: justify;
  line-height: 1.5rem;
  @media screen and (max-width: 1180px) {
    font-size: 1rem;
  }
`;


const HeaderContainer = ({title,content}) => {
  return (
    <HeaderContainerSection>
    <OverlayLayer></OverlayLayer>
    <ContentContainer>
      <LeftContainer>
        <CompanyName>{title}</CompanyName>
        <CompanyContent>
          {content}
        </CompanyContent>
      </LeftContainer>
    </ContentContainer>
  </HeaderContainerSection>
  )
}

export default HeaderContainer
